import types from './types'
import { IndexPage, Common } from '@/networks/api'
// import globalTypes from '@/store/types'
export default {
  state() {
    return {
      images: null,
      gradeAndSubject: null,
      specialCourses: [],
      defaultTerm: null,
      homeCourses: []
    }
  },
  mutations: {
    [types.SET_DEFAULT_TERM](state, payload) {
      state.defaultTerm = payload
    },
    [types.SET_BANNER_IMAGES](state, payload) {
      state.images = payload
    },
    [types.SET_SYNC_COURSE](state, payload) {
      state.syncCourse = payload
    },
    [types.SET_GRADE_SUBJECT](state, payload) {
      state.gradeAndSubject = payload
    },
    [types.SET_LIVETHEMATIC_COURSE_LIST](state, payload) {
      state.liveThematicCourseList = payload
    },
    [types.SET_LITERACY_COURSE_LIST](state, payload) {
      state.literacyCourseList = payload
    },
    [types.SET_HOME_COURSES](state, payload) {
      state.homeCourses = payload
    }
  },
  actions: {
    async [types.GET_BANNER_IMAGES]({ commit, rootState }, { similarId }) {
      const userId = rootState.cookies.stu_id ? rootState.cookies.stu_id : 0
      // const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
      // const { grade = userGrade } = route.params
      const info = {
        grade: Number(similarId),
        area: Number(rootState.xAreaID)
      }
      try {
        const { data } = await Common.getImags(
          { adslot_id: 2, user_id: Number(userId), info },
          { rootState }
        )
        // console.log(data)
        commit(types.SET_BANNER_IMAGES, data.data)
      } catch (e) {
        commit(types.SET_BANNER_IMAGES, [])
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR=====GET_BANNER_IMAGES====', e)
      }
    },
    // 课程标准化，获取首页课程信息
    async [types.GET_HOME_COURSES]({ commit, rootState }, { route }) {
      try {
        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        const { grade = userGrade } = route.params
        const { subjectId = 0, switch_grade = grade, switch_subject = -1 } = route.query
        const provinceId = rootState.xAreaID || 100
        const { data } = await IndexPage.getHomeCourses(
          { rootState, params: {
            provinceId,
            gradeId: grade,
            subjectId,
            switch_grade,
            switch_subject
          } }
        )
        commit(types.SET_HOME_COURSES, data)
      } catch (e) {
        console.log('APIERROR======GET_HOME_COURSES====', e)
        commit(types.SET_HOME_COURSES, [])
      }
    },
    async [types.GET_GRADE_SUBJECT]({ dispatch, commit, rootState }, { route }) {
      // 获取学科年级
      try {
        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        let { grade = userGrade } = route.params
        const { switch_grade = grade, switch_subject = -1 } = route.query
        const provinceId = rootState.xAreaID || 100
        // console.log('====provinceId==========', provinceId, grade)
        if (Number(provinceId) === 9 && Number(grade) === 7) {
          grade = 26
        }
        if (
          Number(provinceId) !== 9 &&
          Number(provinceId) !== 100 &&
          Number(grade) === 26
        ) {
          grade = 7
        }
        const { data, headers } = await IndexPage.getHomeSift(
          { rootState, params: {
            device: 1,
            provinceId,
            gradeId: grade,
            switch_grade, switch_subject
          } }
        )
        // console.log('=======data========', data)
        data && data.subjects && data.subjects.unshift({ id: 0, name: '全部' })
        commit(types.SET_GRADE_SUBJECT, data)
        commit(types.SET_DEFAULT_TERM, headers['x-term-default'])
        const gradeItem =
          data.grades && data.grades.filter(item => Number(item.id) === Number(grade))
        const similarId = gradeItem && gradeItem[0] && gradeItem[0].similarId
        similarId && (await dispatch(types.GET_BANNER_IMAGES, { similarId }))
      } catch (e) {
        console.log('APIERROR======GET_GRADE_SUBJECT====', e)
        commit(types.SET_GRADE_SUBJECT, [])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/IndexPage/store/index.js